"use strict";

/**
 * @classdesc
 * Aktion zum kopieren aller Meldungen des Logbuchs in die Zwischenablage.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.module.GCErrorConsole
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.module.GCErrorConsole} options.instance Modulinstanz
 */
gc.gis.module.GCErrorConsole.DumpAction = function( options )
{
    gc.gis.action.GCAbstractAction.call( this, options );

    this.module = options.instance;

    this.func = function()
    {
        var messages = gc.gis.iface.log.getMessages();
        var tmp = [];
        var keys = Object.keys( messages );
        for( var i=0; i<keys.length; i++ )
        {
            for( var j=0; j<messages[keys[i]].length; j++ )
            {
                tmp.push( messages[keys[i]][j] );
            }
        }
        messages = tmp;

        var debug_text = '';

        for( var i=0; i<messages.length; i++ )
        {
            debug_text += "--------\n"
                +'  time:    '+ messages[i].time +"\n"
                +'  level:   '+ messages[i].level +"\n"
                +'  context: '+ messages[i].context +"\n"
                +'  message: '+ messages[i].message +"\n";
            if( messages[i].message instanceof Error && messages[i].message.stack)
            {
                debug_text += '  stack:   '+ messages[i].message.stack +"\n";
            }
        }

        gc.gis.GCUtil.copyToClipboard( debug_text );
    };
    this.args = [];
};
gc.gis.module.GCErrorConsole.DumpAction.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );
